import {
  createUserWithEmailAndPassword,
  getAuth,
  onAuthStateChanged,
  sendPasswordResetEmail,
  signInWithEmailAndPassword,
  signOut,
} from 'firebase/auth';
import { firebaseApp } from './config';

const auth = getAuth(firebaseApp);

export function userAuthListener(callback: (val: boolean) => void) {
  onAuthStateChanged(auth, (user) => {
    if (user) {
      callback(true);
    } else {
      callback(false);
    }
  });
}

export function getCurrentUserId(): string | undefined {
  const user = auth.currentUser;
  if (user) {
    const uid = user.uid;
    return uid;
  } else {
    return undefined;
  }
}
export function getCurrentUserEmail(): string | undefined {
  const user = auth.currentUser;
  if (user && user.email) {
    return user.email;
  } else {
    return undefined;
  }
}

export async function userSignUp(
  email: string,
  password: string
): Promise<boolean> {
  try {
    const userCredential = await createUserWithEmailAndPassword(
      auth,
      email,
      password
    );
    if (userCredential.user) {
      return true;
    } else {
      return false;
    }
  } catch (e) {
    console.error(e);
    return false;
  }
}
export async function userSignIn(
  email: string,
  password: string
): Promise<boolean> {
  try {
    const userCredential = await signInWithEmailAndPassword(
      auth,
      email,
      password
    );
    if (userCredential.user) {
      return true;
    } else {
      return false;
    }
  } catch (e) {
    console.error(e);
    return false;
  }
}
export async function userSignOut() {
  try {
    signOut(auth);
    return true;
  } catch (e) {
    console.error(e);
    return false;
  }
}

export async function sendPasswortReset(email: string) {
  try {
    await sendPasswordResetEmail(auth, email);
    return true;
  } catch (e) {
    console.log(e);
    return false;
  }
}

export function generateRandomPassword(length = 10) {
  const characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()_+[]{}|;:,.<>?';
  let password = '';

  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    password += characters[randomIndex];
  }

  return password;
}
